import { render, staticRenderFns } from "./EmploymentVCRList.vue?vue&type=template&id=2384fad2&scoped=true&"
import script from "./EmploymentVCRList.vue?vue&type=script&lang=ts&"
export * from "./EmploymentVCRList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2384fad2",
  null
  
)

export default component.exports